module.exports = __webpack_public_path__ + "img/samsung_a217f.10140bc.jpg";